import styled from 'styled-components';

export const Container = styled.div`
  padding: ${({ theme }) => `${theme.spacing.km0} ${theme.spacing.km8}`};
`;

export const Subtitle = styled.h3`
  width: 100%;
  max-width: 532px;
  margin-bottom: 16px;
  font-size: ${({ theme }) => theme.font.size.m6};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  font-style: normal;
  letter-spacing: -0.04em;
`;

export const Text = styled.p`
  width: 100%;
  max-width: 400px;
  margin-bottom: 16px;
  font-size: ${({ theme }) => theme.font.size.m4};
  font-weight: ${({ theme }) => theme.font.weight.regular};
`;
